const optimizedImages = {
  "/assets/solar-roof-hero-1200.jpg": {
    webpSrcSet:
      "/assets/solar-roof-hero-768.webp 768w, /assets/solar-roof-hero-1200.webp 1200w, /assets/solar-roof-hero-1600.webp 1600w",
    sizes: "(min-width: 1024px) 50vw, 100vw",
  },
  "/assets/bess-grossspeicher-scalecube-i3-2026-06-01.png": {
    webpSrcSet:
      "/assets/bess-grossspeicher-scalecube-i3-768.webp 768w, /assets/bess-grossspeicher-scalecube-i3-1200.webp 1200w",
    sizes: "(min-width: 768px) 50vw, 100vw",
  },
  "/assets/pv-dachflaeche-2026-06-01.jpg": {
    webpSrcSet:
      "/assets/pv-dachflaeche-768.webp 768w, /assets/pv-dachflaeche-1200.webp 1200w",
    sizes: "(min-width: 1024px) 25vw, (min-width: 768px) 50vw, 100vw",
  },
  "/assets/kleinspeicher-schwarmspeicher-2026-06-01.jpeg": {
    webpSrcSet: "/assets/kleinspeicher-schwarmspeicher-768.webp 768w",
    sizes: "(min-width: 768px) 50vw, 100vw",
  },
  "/assets/pv-dachflaeche-2026-06-01-193249.jpeg": {
    webpSrcSet: "/assets/pv-dachflaeche-193249-1200.webp 1200w",
    sizes: "(min-width: 768px) 50vw, 100vw",
  },
  "/assets/freiflaechen-pv-800.jpg": {
    webpSrcSet: "/assets/freiflaechen-pv-800.webp 800w",
    sizes: "(min-width: 768px) 50vw, 100vw",
  },
  "/assets/team-lee-ann-klein.png": {
    webpSrcSet: "/assets/team-lee-ann-klein-512.webp 512w",
    sizes: "256px",
  },
  "/assets/team-randy-kirsten.png": {
    webpSrcSet: "/assets/team-randy-kirsten-512.webp 512w",
    sizes: "256px",
  },
  "/assets/team-kilian-elitzke.jpeg": {
    webpSrcSet: "/assets/team-kilian-elitzke-512.webp 512w",
    sizes: "256px",
  },
  "/assets/team-lennart-laabs.jpg": {
    webpSrcSet: "/assets/team-lennart-laabs-512.webp 512w",
    sizes: "256px",
  },
  "/assets/team-lukas-mueller.jpg": {
    webpSrcSet: "/assets/team-lukas-mueller-512.webp 512w",
    sizes: "256px",
  },
  "/assets/team-arne-mallmann.jpeg": {
    webpSrcSet: "/assets/team-arne-mallmann-512.webp 512w",
    sizes: "256px",
  },
  "/assets/team-michael-doerdrechter.jpeg": {
    webpSrcSet: "/assets/team-michael-doerdrechter-512.webp 512w",
    sizes: "256px",
  },
  "/assets/partner-solarea.png": {
    webpSrcSet: "/assets/partner-solarea-352.webp 352w",
    sizes: "176px",
  },
};

export const getOptimizedImage = (src) => optimizedImages[src];

export const ResponsiveImage = ({ src, alt, sizes, ...props }) => {
  const optimized = getOptimizedImage(src);

  if (!optimized) {
    return <img src={src} alt={alt} {...props} />;
  }

  return (
    <picture>
      <source
        type="image/webp"
        srcSet={optimized.webpSrcSet}
        sizes={sizes || optimized.sizes}
      />
      <img src={src} alt={alt} {...props} />
    </picture>
  );
};
